/**
 * 拓扑插件-头部按钮操作事件
 */

export default {
  name: 'custom-attribute-handle',
  options: {
    getEvents() {
      return {
        'custom:header:btn:saveData': 'onCustomHeaderBtnSaveData'
      };
    },
    onCustomHeaderBtnSaveData(evt, b) {
      console.log(evt, '保存事件', b);

    }
  }
};
